import * as React from "react";

const IconHeaderCaretLeft: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" fill="currentColor"><polygon fill="currentColor" points="25.232 5.302 24.767 5.767 20.395 10.142 19.93 10.607 19.003 9.677 19.468 9.212 23.378 5.302 19.465 1.392 19 .927 19.93 0 20.395 .465 24.77 4.837 25.234 5.302" transform="matrix(-1 0 0 1 26.18 .448)"/></svg>;
};

export default React.memo(IconHeaderCaretLeft);
